import React from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { reorder } from '~data/actions/tags';

import { Label, Radio } from '~ui';

export default function SettingsAppTagsSort() {
  const tags_sort = useSelector((state) => state.config.tags_sort);
  const dispatch = useDispatch();

  return (
    <>
      <Label>{t.s('sortTags')}</Label>
      <div>
        {[
          ['_id', t.s('byName')],
          ['-count', t.s('byBookmarksCount')],
        ].map(([key, label]) => (
          <Radio
            key={key}
            name='tags_sort'
            checked={tags_sort == key}
            onChange={() => dispatch(reorder(key))}
          >
            {label}
          </Radio>
        ))}
      </div>
    </>
  );
}
